import React, { useEffect } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { EbookMockup } from './components/EbookMockup';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-wellness-white font-sans text-wellness-dark overflow-x-hidden selection:bg-wellness-sage/30 selection:text-wellness-dark" data-id="element-0">
      <StickyHeader data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <BenefitsSection data-id="element-5" />
        <ForWhoSection data-id="element-6" />
        <EbookMockup data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
      <WhatsAppButton data-id="element-14" />
    </div>;
}